"use client"


import { motion } from "framer-motion"
import { Download, Instagram, Facebook, Youtube, TwitterIcon as TikTok } from "lucide-react"
import { Link } from "react-router-dom"

const VideoDownloader = () => {


 

  const platforms = [
    { name: "Instagram", icon: Instagram, color: "bg-pink-500", link:"/video-downloader/instagram" },
    { name: "Facebook", icon: Facebook, color: "bg-blue-600",link:"/video-downloader/facebook" },
    { name: "YouTube", icon: Youtube, color: "bg-red-600" ,link:"/video-downloader/youtub"},
    { name: "TikTok", icon: TikTok, color: "bg-black" , link:"/video-downloader/tiktok"},
  ]

  return (
    <div className="max-w-4xl mx-auto px-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-8"
      >
        <Download className="inline-block text-indigo-600 mb-4" size={48} />
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white">Video Downloader</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mt-2">
          Download videos from Instagram, Facebook, YouTube, and TikTok easily!
        </p>
      </motion.div>

     

      <motion.div
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.4 }}
      >
        
        {platforms.map((platform, index) => (
            <Link to={platform.link}>
          <motion.div
            key={platform.name}
            className={`${platform.color} p-6 rounded-lg shadow-lg text-white text-center`}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
          >
            <platform.icon size={48} className="mx-auto mb-4" />
            <h3 className="text-xl font-semibold">{platform.name}</h3>
            <p className="mt-2 text-sm opacity-80">Download {platform.name} videos</p>
          </motion.div>
          </Link>
        ))}
      </motion.div>
    </div>
  )
}

export default VideoDownloader

